import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_CARBON_REMOVAL',
  name: 'Workspace Project Carbon Removal',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'exclusions', title: 'Exclusions' },
    { key: 'name', title: 'Name' },
    { key: 'status', title: 'Status' },
    { key: 'myrlin', title: 'Myrlin' },
    { key: 'pools', title: 'Pools' },
    { key: 'baseline', title: 'Baseline' },
    { key: 'harvesting', title: 'Harvesting' },
    { key: 'size', title: 'Size' },
    { key: 'startDate', title: 'Start date' },
    { key: 'endDate', title: 'End date' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
